import api from "./api";

interface SidebarProjectRenameParams {
  project_id: string;
  name: string;
}

interface SidebarProjectRenameProps {
  projectId: string;
  name: string;
}

// 项目重命名
export const sidebarProjectRename = async (props: SidebarProjectRenameProps) => {
  const params: SidebarProjectRenameParams = {
    project_id: props.projectId,
    name: props.name,
  };
  const res = await api.post<unknown>("/sidebar/project/rename", params);
  return res;
};
